import { useState, useContext, useEffect } from "react";
import LogOutaAccount from "./logut/LogOutAccount";
import {
  SabadiIcon,
  UserIcon,
  ArrowLeftIcon,
  LocationIcon,
  PaymentListIcon,
  HeadphoneIcon,
  LogoutIcon,
  SabadiTextIcon,
  CloseIcon
} from "../kits/Icons/Icons.tsx";
import { IoIosCall } from "react-icons/io";
import CustomButton from "../kits/custom-button/CustomButton.tsx";
import ProfileItem from "../kits/profileItem/ProfileItem.jsx";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";
import { NavLink } from "react-router-dom";
import WithLogin from "../../hoc/WithLogin.tsx";
import Drawer from "../drawer/Drawer";
import colorSchema from "../../assets/kits/colors";

import { FaUserTie } from "react-icons/fa";
import BoxSlider from "../common/slider/BoxSlider";
import { getBoxByPosition } from "../../utilities/apiTools";

export default function UserProfile() {
  const auth = useContext(AuthenticationContext);
  console.log("auth", auth.userInfo.access_level.isSuperAdmin);
  console.log("auth", auth);
  const [isOpen, setIsOpen] = useState(false);
  const [profileItem, setProfileItem] = useState([
    {
      title: auth.userInfo.firstname + " " + auth.userInfo.lastname,
      description: "مشاهده و ویرایش اطلاعات شخصی",
      mainIcon: <UserIcon />,
      type: "logged",
      link: "/profile-information",
      superAdmin: false
    },
    {
      title: " مدیریت آدرس ها",
      description: "ویرایش و لیست آدرس ها",
      mainIcon: <LocationIcon />,
      type: "logged",
      link: "/address-management",
      superAdmin: false
    },

    {
      title: " لیست پرداخت ها",
      description: "  لیست پرداخت ها ، تاریخ و وضعیت هر تراکنش",
      mainIcon: <PaymentListIcon />,
      type: "logged",
      link: "/payment-list",
      superAdmin: false
    },
    {
      title: "تماس با پشتیبانی",
      description: "تماس با پشتیبانی سبدی",
      mainIcon: <HeadphoneIcon />,
      type: "logOut",
      isSupport: true,
      superAdmin: false
    },
    {
      title: "درباره سبدی",
      description: "",
      mainIcon: <SabadiIcon />,

      type: "logOut",
      link: "/about-us",
      superAdmin: false
    },
    {
      title: " خروج از حساب کاربری",
      description: "",
      mainIcon: <LogoutIcon />,
      type: "logged",
      modal: "true",
      superAdmin: false
    }
  ]);
  const [isOpenCall, setIsOpenCall] = useState(false);
  const supportCalls = object => {
    if (
      window.navigator.userAgent.indexOf("Windows") != -1 ||
      window.navigator.userAgent.indexOf("X11") != -1
    ) {
      return (
        <div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setIsOpenCall(!isOpenCall)}
          >
            <ProfileItem
              title={object.title}
              description={object.description}
              mainIcon={object.mainIcon}
              moreIcon={<ArrowLeftIcon />}
            />
          </div>
          <Drawer
            isOpen={isOpenCall}
            onClose={() => setIsOpenCall(false)}
            height={90}
          >
            <div className="demo-content ">
              <div className="parent-drawer d-flex justify-content-evenly align-items-center">
                <div className="demo-content text-center mr-t-20 title-h3-m d-flex align-items-center">
                  <IoIosCall className="mr-x-4 call-icon-mirror" />
                  <span> 021-91691584</span>
                </div>
                <div className="text-center">
                  {" "}
                  <CustomButton
                    className="mr-t-20 mr-b-10 "
                    buttonStyle="primary"
                    state="default"
                    size="medium"
                    onClick={() => {
                      setIsOpenCall(false);
                    }}
                  >
                    <CloseIcon
                      color={`${colorSchema.schema_background_main}`}
                    />
                    <span>انصراف</span>
                  </CustomButton>
                </div>
              </div>
            </div>
          </Drawer>
        </div>
      );
    } else {
      return (
        <a href="tel:0214456789" className="profile-link">
          <div>
            <ProfileItem
              title={object.title}
              description={object.description}
              mainIcon={object.mainIcon}
              moreIcon={<ArrowLeftIcon />}
            />
          </div>
        </a>
      );
    }
  };
  useEffect(() => {
    auth.changeUserInfo({
      firstname: auth.userInfo.firstname,
      lastname: auth.userInfo.lastname
    });
    setProfileItem(prev => {
      prev[0].title = auth.userInfo.firstname + " " + auth.userInfo.lastname;
      return prev;
    });
  }, [auth.userInfo.firstname, auth.userInfo.lastname]);

  console.log("auth", auth);

  useEffect(() => {
    let temp = [...profileItem];
    console.log("temp", temp);
    if (
      auth.userInfo.access_level.isSuperAdmin == true &&
      profileItem[1]?.title != "پنل سوپرادمین"
    ) {
      profileItem.splice(1, 0, {
        title: "پنل سوپرادمین",
        description: "افزودن و ویرایش اطلاعات محصولات و فروشگاهها",
        mainIcon: <FaUserTie />,
        type: "logged",
        link: "/super-admin-panel",
        superAdmin: true
      });
    } else if (
      auth.userInfo.access_level.supplierList.length > 0 &&
      auth.userInfo.access_level.isSuperAdmin == false
    ) {
      auth.userInfo.access_level.supplierList?.map((val, ind) => {
        console.log("xxx", val);

        profileItem.splice(1, 0, {
          title: `پنل ادمین فروشگاه ${val.title ? val.title : "---"}`,
          description: "افزودن و ویرایش اطلاعات محصولات و فروشگاهها",
          mainIcon: <FaUserTie />,
          type: "logged",
          link: `/admin-panel/${val.id}`,
          superAdmin: false
        });
      });
    }
    console.log("profile item", profileItem);
    // setProfileItem(temp);
  }, [auth, auth.userInfo.access_level.isSuperAdmin]);

  const [boxBanners, setBoxBanners] = useState({});

  useEffect(() => {
    const loadBanner = async () =>
      setBoxBanners(await getBoxByPosition("d9,d10"));
    loadBanner();
  }, []);

  return (
    <div className="userProfile-style">
      <div className="mr-x-20 mr-t-20 mr-b-16">
        <SabadiTextIcon width={66} height={32} />
      </div>

      <hr className="top-line" />

      <div>
        {auth.isLogin == false && (
          <div className="mr-t-40">
            {boxBanners.d9 && (
              <div className="mr-b-20 pd-x-20">
                <BoxSlider banner={boxBanners.d9} />
              </div>
            )}

            <p className="text-start  pd-x-20 desc-c-l">
              برای استفاده از امکانات و خرید از سبدی وارد حساب کاربری خود شوید.
            </p>

            <div className="d-flex justify-content-center mr-t-20 mr-b-40">
              <WithLogin
                className="custom-button title-h4-m "
                buttonStyle="primary"
                size="large"
              >
                ورود به حساب کاربری
              </WithLogin>
            </div>
            <hr className="line" />
          </div>
        )}

        {auth.isLogin && boxBanners.d10 && (
          <div className="mr-b-20 pd-x-20">
            <BoxSlider banner={boxBanners.d10} />
          </div>
        )}

        {profileItem.reduce((total, value) => {
          if (!auth.isLogin && value.type == "logged") {
            return total;
          }

          let component = (
            <ProfileItem
              title={value.title}
              description={value.description}
              mainIcon={value.mainIcon}
              moreIcon={<ArrowLeftIcon />}
            />
          );
          total.push(
            <>
              {total.length != 0 && <hr className="line mr-l-20 mr-r-40" />}
              <div className=" mr-y-16 mr-x-20 items">
                {value.modal == "true" ? (
                  <CustomButton
                    className="w-100"
                    buttonStyle="text"
                    style={{ padding: 0 }}
                    onClick={() => {
                      setIsOpen(true);
                    }}
                  >
                    {component}
                  </CustomButton>
                ) : value.isSupport ? (
                  supportCalls(value)
                ) : (
                  <NavLink to={value.link} className="profile-link">
                    {component}
                  </NavLink>
                )}
              </div>
            </>
          );
          return total;
        }, [])}
        <LogOutaAccount isOpen={isOpen} setIsOpen={setIsOpen}></LogOutaAccount>
      </div>
    </div>
  );
}
